import { render, staticRenderFns } from "./Flashcard.vue?vue&type=template&id=59c48ef5&scoped=true&"
import script from "./Flashcard.vue?vue&type=script&lang=js&"
export * from "./Flashcard.vue?vue&type=script&lang=js&"
import style0 from "./Flashcard.vue?vue&type=style&index=0&id=59c48ef5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c48ef5",
  null
  
)

export default component.exports